import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import React, {Fragment} from 'react'
import {CSSTransition} from 'react-transition-group'
import {colors} from '../styles'
import {css} from 'glamor'

const LEFT = 'left'
const RIGHT = 'right'

const style = {
  bodyOpen: css({
    overflow: 'hidden'
  }),
  background: css({
    background: 'rgba(0, 0, 0, 0.6)',
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    width: '100%',
    zIndex: 1
  }),
  contents: ({from}) =>
    css({
      background: colors.white,
      bottom: 0,
      boxShadow: `${10 * from === LEFT ? 1 : -1}px 0 10px rgba(0, 0, 0, 0.1)`,
      maxWidth: '320px',
      overflowX: 'hidden',
      overflowY: 'scroll',
      position: 'fixed',
      [from]: 0,
      top: 0,
      transition: `${from} 0.2s`,
      width: '100%',
      zIndex: 1,
      '&.flyout-enter': {
        [from]: '-100%'
      },
      '&.flyout-enter.flyout-enter-active': {
        [from]: '0'
      }
    })
}

const Flyout = ({backdrop, children, from, onHide, show, ...rest}) =>
  show && (
    <Fragment>
      <Helmet>
        <body {...style.bodyOpen} />
      </Helmet>
      <div {...rest}>
        {backdrop && <div onClick={onHide} {...style.background} />}
        <CSSTransition
          classNames="flyout"
          appear={true}
          enter={false}
          timeout={{enter: 200, exit: 200}}
        >
          <div key="content" {...style.contents({from})}>
            {children}
          </div>
        </CSSTransition>
      </div>
    </Fragment>
  )

Flyout.propTypes = {
  backdrop: PropTypes.bool,
  children: PropTypes.any,
  from: PropTypes.oneOf([LEFT, RIGHT]),
  onHide: PropTypes.func,
  show: PropTypes.bool.isRequired
}

Flyout.defaultProps = {
  backdrop: true,
  from: 'left'
}

export default Flyout
